export default __webpack_public_path__ + "images/4f934fc94318b6368d9f094eefddfe9c-language-icon--el.svg";